export default class FnEditorStack {
    constructor(logger) {
        this.logger = logger;
        this.actionSets = [];
        this.pointer = -1;
    }
    add(actionSet) {
        if (this.pointer < this.actionSets.length - 1) {
            // redo not possible anymore
            this.actionSets.splice(this.pointer + 1);
        }
        this.actionSets.push(actionSet);
        this.pointer++;
        this.logger.log('added to stack', this.actionSets, this.pointer);
    }
    undo() {
        const actionSet = this.actionSets[this.pointer];
        if (!actionSet) {
            this.logger.log('cannot undo');
            this.logger.log('stack now', this.actionSets, this.pointer);
            return null;
        }
        this.pointer--;
        this.logger.log('undo from stack', actionSet);
        this.logger.log('stack now', this.actionSets, this.pointer);
        return actionSet;
    }
    redo() {
        const actionSet = this.actionSets[this.pointer + 1];
        if (!actionSet) {
            this.logger.log('cannot redo');
            this.logger.log('stack now', this.actionSets, this.pointer);
            return null;
        }
        this.pointer++;
        this.logger.log('redo from stack', actionSet);
        this.logger.log('stack now', this.actionSets, this.pointer);
        return actionSet;
    }
    clear() {
        this.pointer = -1;
        this.actionSets = [];
    }
}
